"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegratedGiftCardMap = exports.IntegratedGiftCardProviders = exports.PASSWORD_RESET_VALIDITY_HOURS = exports.USE_SSL_API_IN_DEV = exports.MAIN_PRIZE_STRUCTURE_CODE = exports.BUSINESS_TIME_ZONE = exports.Monthly10k = exports.TreatPrizeTierCodes = exports.PrizeTierMap = exports.PRIZE_WIN_VALIDITY_IN_DAYS = exports.AUTOFULFILMENT_CODES = exports.S3_BUCKET_NAME_LEADERBOARD_ASSETS = exports.S3_BUCKET_NAME_PRIZE_ASSETS = exports.DEFAULT_SPEND_LIMIT_FIAT_AMOUNT_IN_PENCE = void 0;
/**
 * Default monthly spend limit.
 * Equals to (maxed out weekly subscription price x 5 weeks).
 * Can be overridden on a player-by-player basis via the spendLimitPence field on the player table.
 */
exports.DEFAULT_SPEND_LIMIT_FIAT_AMOUNT_IN_PENCE = 12000;
/** The bucket name for Prize Assets. This name is also used to build S3 bucket URLs */
exports.S3_BUCKET_NAME_PRIZE_ASSETS = 'daymade-prize-assets';
/** The bucket name for Leaderboard Assets. This name is also used to build S3 bucket URLs */
exports.S3_BUCKET_NAME_LEADERBOARD_ASSETS = 'triphunters-leaderboard-photos';
exports.AUTOFULFILMENT_CODES = {
    DAYMADE_TOKEN: 'DAYMADE_TOKEN',
    TREE: 'TREE',
    MAIN_DRAW_PREMIUM_ENTRY: 'MAIN_DRAW_PREMIUM_ENTRY',
    GIFTCLOUD_REWARD: 'GIFTCLOUD_REWARD',
};
/** Number of days players have to claim their prizes */
exports.PRIZE_WIN_VALIDITY_IN_DAYS = 28;
/** A mapping of prize tiers codes to human-friendly names */
exports.PrizeTierMap = {
    Treat1: 'Treat 1',
    Treat2: 'Treat 2',
    Treat3: 'Treat 3',
    Bronze: 'Bronze prize',
    Silver: 'Silver prize',
    Gold: 'Gold prize',
    Platinum: 'Platinum prize',
    Diamond: 'Diamond prize',
    DAYMAKER: 'DAYMAKER prize',
    DAYMAKERboost: 'DAYMAKER+ prize',
};
exports.TreatPrizeTierCodes = [
    'Treat1',
    'Treat2',
    'Treat3',
];
exports.Monthly10k = {
    /** The URL path for the monthly 10k draws, intended to be used to link  */
    urlPath: '/monthly-10k-giveaway',
    abTestName: 'MonthlyGiveaway',
    abTestValue: 'YES',
    drawTypeCode: 'MONTHLY_GIVEAWAY',
    drawTypePlanCode: 'MONTHLY_GIVEAWAY',
    drawTypePlanSubcode: 'BASE',
    /** The number of entries earnt per week. Note that users may be able to earn
     * additional entries for other actions, which are not included in this value
     **/
    minimumEntriesPerWeek: 5,
    /** The days of the month that entries are awarded for February */
    entryAwardDayOfMonthFeb: [1, 8, 15, 21, 28],
    /** The days of the month that entries are awarded for other months */
    entryAwardDayOfMonthOther: [1, 8, 15, 21, 29],
};
exports.BUSINESS_TIME_ZONE = 'Europe/London';
exports.MAIN_PRIZE_STRUCTURE_CODE = 'DMDP';
/** Whether to use SSL for the API when running in local environment. See notes
 * on this page to see why we would want to do that:
 * https://www.notion.so/daymadeuk/Testing-on-other-devices-30c23e7cd84080a2b78bd8caf59d9b9c */
exports.USE_SSL_API_IN_DEV = false;
exports.PASSWORD_RESET_VALIDITY_HOURS = 24;
exports.IntegratedGiftCardProviders = ['GIFTCLOUD'];
exports.IntegratedGiftCardMap = {
    GIFTCLOUD: {
        5: '£5',
        10: '£10',
        15: '£15',
        20: '£20',
        25: '£25',
        30: '£30',
        50: '£50',
        100: '£100',
        150: '£150',
        300: '£300',
        500: '£500',
        wwf5: '£5 (Win With Friends)',
        wwf15: '£15 (Win With Friends)',
        wwf200: '£200 (Win With Friends)',
        wwf500: '£500 (Win With Friends)',
        wwf1000: '£1000 (Win With Friends)',
        wwf5000: '£5000 (Win With Friends)',
    },
};
//# sourceMappingURL=constants.js.map